import { useLocalization } from "@/contexts/Localization";
import { IImage, Languages } from "@/src/types";
import { Link } from "gatsby";
import React, { useState } from "react";
import S from "./LanguageSelector.styled";

import { getImage, GatsbyImage } from "gatsby-plugin-image";

type Props = {
  icon: IImage;
  isOpen: boolean;
  scrolled: number;
};

export const LanguageSelector: React.FC<Props> = ({
  icon,
  isOpen,
  scrolled,
}) => {
  const { language, translations } = useLocalization();
  const [showOptions, setShowOptions] = useState(false);

  const translation = translations.find((t) => t.language.slug === language);

  const languageIconImage = icon?.gatsbyImage
    ? getImage(icon.gatsbyImage)
    : null;

  return (
    <S.Container onClick={() => setShowOptions(!showOptions)}>
      <S.Hamburger
        onClick={() => setShowOptions(!showOptions)}
        active={showOptions}
      >
        <S.HamburgerLine1
          active={showOptions}
          scrolled={scrolled}
          isOpen={isOpen}
        />
        <S.HamburgerLine2
          active={showOptions}
          scrolled={scrolled}
          isOpen={isOpen}
        />
        <S.HamburgerLine3
          active={showOptions}
          scrolled={scrolled}
          isOpen={isOpen}
        />
      </S.Hamburger>
      <S.Icon scrolled={scrolled} open={showOptions} isOpen={isOpen}>
        {languageIconImage && (
          <GatsbyImage
            className="gatsby-image"
            image={languageIconImage}
            alt={icon.altText}
          />
        )}
      </S.Icon>
      <S.Ul open={showOptions}>
        <S.Li active={language === Languages.Swedish}>
          <Link to="/">🇸🇪 Svenska</Link>
        </S.Li>
        <S.Li active={language === Languages.Norwegian}>
          <Link to={translation ? translation.uri : "/no"}>🇳🇴 Norsk</Link>
        </S.Li>
        <S.Li active={language === Languages.English}>
          <Link to={translation ? translation.uri : "/en"}>🇬🇧 English</Link>
        </S.Li>
      </S.Ul>
    </S.Container>
  );
};
